var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0-1A6 6 0 1 0 8 2a6 6 0 0 0 0 12zm.2-4.418a.5.5 0 0 1-1 0V9c0-.32.181-.533.476-.72.206-.13 1.17-.567 1.201-.583C9.647 7.316 10 6.957 10 6.5 10 5.481 9.094 5 7.7 5c-.673 0-1.242.361-1.474.914a.5.5 0 0 1-.922-.387C5.695 4.595 6.633 4 7.7 4 9.573 4 11 4.758 11 6.5c0 .95-.602 1.559-1.678 2.093-.091.045-.974.445-1.111.532a.05.05 0 0 1-.012.006v.451zM7 11.25c0-.138.223-.25.5-.25.275 0 .5.112.5.25l.002.5c0 .138-.223.25-.5.25-.276 0-.5-.112-.5-.25L7 11.25z" })
  );
});